/*       */

import { gql } from '@apollo/client';

export default gql`
    query integrationsQuery($username: String!) {
        records: userLoginActions(username: $username)
    }
`;
